import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const Checkbox = ({ onToggle, id, checked, disabled, label, width = '24px', height = '24px', viewBox = '0 0 48 48', isStopPropagation = false }) => {

    const indeterminate = checked === null || checked === undefined;
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);

    const handleToggle = (e) => {
        isStopPropagation && e.stopPropagation();
        if (typeof onToggle === 'function' && !disabled) {
            onToggle();
        }
    };

    return (
        <label
            htmlFor={id}
            className={disabled ? 'custom-checkbox-disabled' : 'custom-checkbox'}>
            {label ? <div className='checkbox-label'>{label}</div> : null}
            <input
                ref={inputRef}
                id={id}
                type='checkbox'
                checked={!!checked}
                onChange={handleToggle}
                onClick={(e) => { isStopPropagation && e.stopPropagation(); }}
                disabled={disabled}
                aria-checked={indeterminate ? 'mixed' : !!checked}
                className='checkbox-input'
                style={{ position: 'absolute', opacity: 0, width: '100%', height: '100%', margin: 0, cursor: disabled ? 'default' : 'pointer' }}
            />
            <svg className='checkbox' width={width} height={height} viewBox={viewBox} xmlns='http://www.w3.org/2000/svg'>
                <g fill='none'>
                    <rect className={checked || indeterminate ? 'fill-checked' : 'fill-empty'} x='6.4688' y='6.2812' width='35.344' height='35.344' strokeLinecap='square' strokeWidth='5' />
                    {indeterminate ?
                        <rect className={indeterminate ? 'indeterminate' : 'fill-white'} x='12' y='21' width='24' height='6' />
                        : checked &&
                        <path d='m14.385 25.063 7.0269 6.4303 12.728-15.844' strokeWidth='4.5' />
                    }
                </g>
            </svg>
        </label>
    );
};

Checkbox.propTypes = {
    id: PropTypes.string,
    checked: PropTypes.oneOf([true, false, null]),
    onToggle: PropTypes.func,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    isStopPropagation: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string
};

export default Checkbox;
